import React from 'react'
import {linkedin, twitter, github} from "../../assets"

function LinkIcon({ link, icon, alt }) {
    return (
        <a href={link} target="_blank" className="icon__link">
            <img src={icon} alt={alt}/>
        </a>
    );
}

function RoleCard({ data }) {
    return (
        <div id="rolecard">
            <div className="head">
                <span className="__photo" style={{backgroundImage: `url(${data.photo})`}}></span>
                <div className="infos">
                    <h6>{ data.fullName }</h6>
                    <span>{ data.role }</span>
                </div>
            </div>
            <p>{ data.description }</p>
            <div className="contact">
                {(data.contact.linkedin !== "" && <LinkIcon link={data.contact.linkedin} icon={linkedin} alt="Linkedin" />)}
                {(data.contact.github !== "" && <LinkIcon link={data.contact.github} icon={github} alt="Github" />)}
                {(data.contact.twitter !== "" && <LinkIcon link={data.contact.twitter} icon={twitter} alt="Twitter" />)}
            </div>
        </div>
    )
}

export default RoleCard;
